var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        { attrs: { outlined: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { dense: "", color: "primary", dark: "" } },
            [
              _c("v-toolbar-title", [_vm._v("Quotations")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { small: "", text: "", to: "/quotations/create" } },
                [
                  _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-plus")]),
                  _vm._v(" New ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("v-text-field", {
                staticClass: "mb-3",
                attrs: {
                  label: "Search",
                  "prepend-inner-icon": "mdi-magnify",
                  clearable: "",
                  dense: "",
                  outlined: "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              }),
              _c("v-data-table", {
                attrs: {
                  "footer-props": { itemsPerPageOptions: [10, 25, 50, 10000] },
                  headers: _vm.headers,
                  items: _vm.items,
                  loading: _vm.loading,
                  options: _vm.options,
                  "server-items-length": _vm.total,
                  dense: ""
                },
                on: {
                  "update:options": function($event) {
                    _vm.options = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.is_locked",
                    fn: function({ item }) {
                      return [
                        _c(
                          "v-chip",
                          {
                            attrs: {
                              color: item.is_locked ? "red" : "green",
                              dark: "",
                              small: ""
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(item.is_locked ? "Locked" : "Open") +
                                " "
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.customer",
                    fn: function({ value }) {
                      return [
                        _c("small", [_vm._v("(" + _vm._s(value.id) + ")")]),
                        _vm._v(" " + _vm._s(value.name))
                      ]
                    }
                  },
                  {
                    key: "item.actual_date",
                    fn: function({ value }) {
                      return [_vm._v(_vm._s(_vm.formatDateUS(new Date(value))))]
                    }
                  },
                  {
                    key: "item.items_total_amount",
                    fn: function({ value }) {
                      return [
                        _vm._v(" " + _vm._s(_vm.currencyFormat(value)) + " ")
                      ]
                    }
                  },
                  {
                    key: "item.project_code",
                    fn: function({ value }) {
                      return [_vm._v(_vm._s(value?.code || "-"))]
                    }
                  },
                  {
                    key: "item.actions",
                    fn: function({ item }) {
                      return [
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "success", icon: "", small: "" },
                            on: {
                              click: function($event) {
                                return _vm.printPdf(item)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-printer")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "purple", icon: "", small: "" },
                            on: {
                              click: function($event) {
                                return _vm.view(item.id)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-eye")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "yellow darken-3",
                              icon: "",
                              small: "",
                              disabled: item.is_locked
                            },
                            on: {
                              click: function($event) {
                                return _vm.edit(item.id)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-pencil")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: item.is_locked ? "green" : "red",
                              icon: "",
                              small: ""
                            },
                            on: {
                              click: function($event) {
                                item.is_locked
                                  ? _vm.unlock(item)
                                  : _vm.lock(item)
                              }
                            }
                          },
                          [
                            _c("v-icon", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.is_locked
                                      ? "mdi-lock-open"
                                      : "mdi-lock"
                                  ) +
                                  " "
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              disabled: item.is_locked,
                              color: "red",
                              icon: "",
                              small: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.destroy(item)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-delete")])],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }